var _circle, _path, _circle2, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 21,
    r: 6,
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 24C6.34315 24 5 22.6569 5 21",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 5.93333,
    transform: "matrix(-1 0 0 1 24.0667 20.9333)",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24.2C25.7673 24.2 27.2 22.7673 27.2 21",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 17L19 17",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25H19V23H13V25Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2367 10.2978L22.3003 10.6489V10.6489L23.2367 10.2978ZM8.76334 10.2978L7.82701 9.94663V9.94663L8.76334 10.2978ZM10.636 10H21.364V8H10.636V10ZM22.3003 10.6489L24.0637 15.3511L25.9363 14.6489L24.173 9.94663L22.3003 10.6489ZM7.93633 15.3511L9.69967 10.6489L7.82701 9.94663L6.06367 14.6489L7.93633 15.3511ZM21.364 10C21.7808 10 22.154 10.2586 22.3003 10.6489L24.173 9.94663C23.7339 8.77572 22.6145 8 21.364 8V10ZM10.636 8C9.38547 8 8.26611 8.77572 7.82701 9.94663L9.69967 10.6489C9.84604 10.2586 10.2192 10 10.636 10V8Z",
    fill: "currentColor"
  })));
}
export default SvgView;